<template>
  <div>
    <template v-if="access == 'admin'">
      <template v-if="currentUser && currentUser.roleAdmin === true">
        <v-btn
          :aria-label="$t('Изменить доступ админа') + ': ' + (user.admin_access ? $t('Активен') : $t('Не активен'))"
          @click.native.stop="editAccess"
        >
          <span>
            {{ user.admin_access ? $t('Активен') : $t('Не активен') }}
          </span>
        </v-btn>
      </template>
      <template v-else>
        <span>
          {{ user.admin_access ? $t('Активен') : $t('Не активен') }}
        </span>
      </template>
    </template>
    <template v-if="access == 'spec'">
      <v-btn
        :aria-label="$t('Изменить доступ специалиста') + ': ' + (user.specialist_access ? $t('Активен') : $t('Не активен'))"
        @click.native.stop="editAccess"
      >
        <span>
          {{ user.specialist_access ? $t('Активен') : $t('Не активен') }}
        </span>
      </v-btn>
    </template>
    <v-dialog v-model="accessDialog" max-width="800">
      <v-card class="modal modal-change-access">
        <div class="modal-head">
          {{ $t('Управление доступами') }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="resetAccess(false)">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="position">
            <div class="bg-white p-20">
              <v-form
                class="form-ru"
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="changeAccess"
              >
                <div class="form-body">
                  <div class="form-col-2">
                    <div class="form-group">
                      <div class="row"
                           :class="{ invalid: $v.accessJournal.status.$error }"
                      >
                        <div class="col-sm-3">
                          <div class="flexbox">
                            <label for="status">
                              {{ $t("Статус") }}
                              <span class="asterix">*</span>
                            </label>
                            <fieldInfo />
                          </div>
                        </div>
                        <div class="col-sm-9">
                          <v-select
                            id="status"
                            :items="refAllowanceProgramStatus"
                            return-value
                            item-value="id"
                            item-text="transName"
                            v-model="accessJournal.status"
                            required
                            :aria-label="$t('Статус')"
                            :aria-invalid="$v.accessJournal.status.$error ? 'true' : 'false'"
                            outlined
                            dense
                            clearable
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="state" class="form-group">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="flexbox">
                            <label for="reason">
                              {{ $t("Причина") }}
                            </label>
                            <fieldInfo />
                          </div>
                        </div>
                        <div class="col-sm-9">
                          <v-select
                            id="reason"
                            :items="refAllowanceStopProgReason"
                            return-value
                            item-value="id"
                            item-text="transName"
                            v-model="accessJournal.reason"
                            required
                            :aria-label="$t('Причина')"
                            outlined
                            dense
                            clearable
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="state" class="form-group">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="flexbox">
                            <label for="text">
                              {{ $t("Комментарий") }}
                            </label>
                            <fieldInfo/>
                          </div>
                        </div>
                        <div class="col-sm-9">
                          <v-textarea
                            v-model="accessJournal.comment"
                            :aria-label="$t('Комментарий')"
                            outlined
                          />
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="form-action">
                  <button
                    class="btn btn-default blue"
                    type="submit"
                  >
                    {{ $t('Сохранить') }}
                  </button>
                  <button
                    class="btn btn-default gray"
                    type="button"
                    @click="resetAccess(false)"
                  >
                    {{ $t('Отмена') }}
                  </button>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import User from '@/model/user'
  import {required} from 'vuelidate/lib/validators'
  import fieldInfo from '@/components/app/fieldInfo'
  import {mapMutations} from 'vuex'

  export default {
    components: {
      fieldInfo
    },
    props: {
      user: Object,
      access: String,
      state: Boolean
    },
    data: () => ({
      accessDialog: false,
      refAllowanceProgramStatus: [],
      refAllowanceStopProgReason: [],
      accessJournal: {},
      valid: true,
      rules: {
        accessJournal: {
          status: {required}
        }
      },
    }),
    computed: {
      currentUser() {
        return this.$store.state.getUser.currentUser
      }
    },
    validations() {
      return this.rules
    },
    methods: {
      ...mapMutations(['setLoading']),
      // Валидация формы
      validateForm() {
        this.$v.$touch()

        if (this.$v.$invalid) {
          this.$nextTick(() => {
            this.scrollToFirstError()
          })

          return false
        }

        return true
      },
      editAccess() {
        User.getAllowanceStatuses(this.user.id, this.access)
          .then((response) => {
            this.refAllowanceProgramStatus = response.data.refAllowanceProgramStatus
            this.refAllowanceStopProgReason = response.data.refAllowanceStopProgReason
          })
          .catch((error) => {
            console.log(error)
          })
        this.resetAccess(true)
      },
      // Обновление формы
      resetAccess(flag) {
        this.accessDialog = flag
      },
      // Изменение доступа
      changeAccess() {
        if (!this.validateForm()) return
        this.setLoading(true)
        User.changeAccess(this.user.id, this.access, this.accessJournal)
          .then((response) => {
            if (response.status === 200) this.$parent.fetchData()
            this.resetAccess(false)
            this.setLoading(false)
          })
          .catch((error) => {
            console.log(error)
            this.setLoading(false)
          })
      },
      // Прокручивание до поля с ошибкой
      scrollToFirstError() {
        const domRect = document.querySelector('.invalid').getBoundingClientRect()
        window.scrollTo(
          domRect.left +
          (document.body.scrollLeft || document.documentElement.scrollLeft),
          domRect.top +
          (document.body.scrollTop || document.documentElement.scrollTop) -
          90
        )
      },
    }

  }
</script>
